import { useEffect } from "react";
import { TextPage, TextSection } from "@/components/TextPage";

export default function DisclosurePage() {
  useEffect(() => {
    document.title = "Affiliate Disclosure — Findora";
  }, []);

  return (
    <TextPage
      testId="disclosure-page"
      eyebrow="Transparency"
      title="Affiliate Disclosure"
    >
      <TextSection testId="disclosure-intro">
        <p>
          Findora is a participant in the Amazon Services LLC Associates
          Program, an affiliate advertising program designed to provide a means
          for sites to earn advertising fees by advertising and linking to
          Amazon.com. As an Amazon Associate, Findora earns from qualifying
          purchases made through links on this site, at no additional cost to
          you.
        </p>
      </TextSection>

      <TextSection title="How this works" testId="disclosure-how-this-works">
        <p>
          When a product card on this site links to Amazon, clicking it takes
          you to Amazon's own website to view and purchase that item. Findora
          does not process payments, ship products, or handle returns for
          anything sold on Amazon — that relationship is between you and Amazon.
          If you make a qualifying purchase after following one of our links,
          Amazon pays Findora a small referral commission. This does not change
          the price you pay. The price you pay is exactly the same whether you
          use my link or go directly to the retailer. Affiliate partnerships
          never influence which products I recommend, how I rate them, or what I
          write in my reviews.
        </p>
      </TextSection>

      <TextSection title="Editorial independence" testId="disclosure-editorial-independence">
        <p>
          Products are chosen based on our own research and, where noted,
          personal use. Being included on this list is never paid for by a brand
          or seller, and commission potential does not determine which products
          are featured.
        </p>
      </TextSection>

      <TextSection title="Questions" testId="disclosure-questions">
        <p>
          If you have questions about this disclosure, contact us at the address
          listed on our Privacy Policy page.
        </p>
      </TextSection>
    </TextPage>
  );
}
